import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=8415a3ae&scoped=true"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"
import style0 from "./Editor.vue?vue&type=style&index=0&id=8415a3ae&prod&lang=scss&scoped=true"
import style1 from "./Editor.vue?vue&type=style&index=1&id=8415a3ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8415a3ae",
  null
  
)

export default component.exports